import { AnalyticsManager } from './analytics';
import { MapsManager } from './maps';

export class CookieManager {
  static init() {
    AnalyticsManager.checkCookies();
    MapsManager.checkCookies();

    if (!(CookieManager.getCookie('cookie_consent') === 'accepted' ||
      CookieManager.getCookie('cookie_consent') === 'denied')) {
      $('#cookie__popup').removeClass('hidden');
    }

    if (CookieManager.getCookie('cookie_consent') === 'accepted') {
      $('#map').removeClass('hidden');
      $('#no_maps_allowed').addClass('hidden');
    }


    $('#cookie__popup__no').on('click', function () {
      CookieManager.eraseCookie('cookie_consent');
      CookieManager.setCookie('cookie_consent', 'denied', 100);
      $('#cookie__popup').addClass('hidden');
      $('#map').addClass('hidden');
      $('#no_maps_allowed').removeClass('hidden');

      AnalyticsManager.checkCookies();
      MapsManager.checkCookies();
    });

    $('#cookie__popup__btn').on('click', function () {
      CookieManager.eraseCookie('cookie_consent');
      CookieManager.setCookie('cookie_consent', 'accepted', 100);
      $('#cookie__popup').addClass('hidden');
      $('#no_maps_allowed').addClass('hidden');
      $('#map').removeClass('hidden');
      AnalyticsManager.checkCookies();
      MapsManager.checkCookies();
    });

    $('#cookie__map__btn').on('click', function () {
      CookieManager.eraseCookie('cookie_consent');
      CookieManager.setCookie('cookie_consent', 'accepted', 100);
      $('#cookie__popup').addClass('hidden');
      $('#no_maps_allowed').addClass('hidden');
      $('#map').removeClass('hidden');
      AnalyticsManager.checkCookies();
      MapsManager.checkCookies();
    });
  }

  static setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  }

  static eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }

  static getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}
